import { View, StyleSheet } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import { QUESTION_COUNTER_HEIGHT } from "../../../constants/assessmentConstants";

const QuestionCounter = ({ questionIndex, totalQuestions }: { questionIndex: number; totalQuestions: number }) => {
  if (questionIndex === 0) return null;

  return (
    <View style={styles.questionCounter}>
      <CustomText
        text="current_question_index"
        size="s"
        interpolation={{ questionIndex, totalQuestions }}
        style={styles.questionCounterText}
      />
    </View>
  );
};

export default QuestionCounter;

const styles = StyleSheet.create({
  questionCounter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#E6EBFF",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 360,
    gap: 10,
    height: QUESTION_COUNTER_HEIGHT,
  },
  questionCounterText: {
    color: "#344054",
    opacity: 0.8,
  },
});
